<template>

    <div class="main-body position-relative">
    
      <div class="nav-title position-absolute">
          <div class="flex flex-center-cz margin-left-xl font-xl font-bold">
            <span class="pointer" >我的点赞</span>
          </div>
      </div>
      <div class="file-pnl" style="margin-top:45px">
            <div v-for="item in likeData" class="file-box position-relative">
              <div class="pointer dir-box" @click="gridItemClick" :data-id="item.id" >
                <img v-if="item.cover != null" class="file-img" :src="item.cover" :data-id="item.id"/>
                <div v-if="item.cover == null" class="file-img padding-s font-s border-box">{{item.summary}}</div>
              </div>
              <div class="file-desc">
                <div class="file-left">
                  <div class="file-name">{{item.name}}</div>
                  <div class="flex flex-row file-remark">
                    <div class="margin-right-l flex flex-row" style="width:40px"><img class="dianzan-ico" src="@/assets/images/dianzan.png"/><div class="margin-left-m ">1</div></div>
                    <div class="margin-right-l flex flex-row" style="width:45px"><img class="chakan-ico" src="@/assets/images/chakan.png"/><div class="margin-left-m ">33</div></div>
                    <div class="margin-right-l flex flex-row" style="width:45px"><img class="pinglun-ico" src="@/assets/images/pinglun.png"/><div class="margin-left-m ">12</div></div>
                    <div class="margin-right-l flex flex-row" style="width:45px"><img class="shoucang-ico" src="@/assets/images/shoucang.png"/><div class="margin-left-m ">10</div></div>
                  </div>
                </div>
                <div class="file-right">
                  <div class="file-share pointer"><img class="share-img" src="@/assets/images/share.png"/></div>
                  <div class="file-more pointer"  @click="showMore"><img class="more-img" src="@/assets/images/icmore.png" /></div>
                </div>
              </div>          
            </div>
      </div>    
      
      <popup-menu ref="child" :menuData="menuData"  @menuClick="menuClick(arguments)" >
      </popup-menu>

    </div>     
    
    </template>
    
    <script>
      /*
            名称：我的收藏
            功能：
            作者：唐赢   
            时间：2023-1-24
      */
    
      import * as likeData from "@/assets/data/likeData.js?1"
      import PopupMenu from '@/components/popupMenu/PopupMenu' 

      export default {
        name: 'Main',
        components: {
          PopupMenu
        },
        data () {
          return {
            menuData:[{id:'cancel',name:'取消收藏'}],   //菜单数据 
            likeData: likeData.likeData            
          }
        },
        created() {
        },
        methods: {

            gridItemClick(event) {
                console.log(event);

            },  

            showMore(event) {
                this.$refs.child.show(event);//调用子组件的show方法，用于显示弹出式菜单，引用组件时，需要 ref="child"

            },
            menuClick(args) {
              let id = args[0];
              alert("您点击了：" + id);
            },
            stopPropa(event) {
                event || (event = window.event);
                event.stopPropagation ? event.stopPropagation(): (event.cancelBubble = true);
                document.addEventListener("click", this.closeClick, false);// 监听关闭事件
            },
    
            closeClick(e) {
                console.log("销毁监听事件。");
                document.removeEventListener("click", this.closeClick, false);
                this.showOpMenu = false;
            },

          
        }
      }
    </script>
    
      <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
        .dir-box {
            height: 170px;
        }
    
    </style>
      


// WEBPACK FOOTER //
// src/views/Likes.vue